import React, { useState } from 'react'
import {
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Dialog,
  Checkbox,
  FormControlLabel,
  Typography,
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { Translate } from 'react-localize-redux'

const PlayerUnavailableAlertDialog = ({ open, onClose, onSuccess }) => {
  const [doNotShowAgain, setDoNotShowAgain] = useState(false)
  const handleSubmit = () => {
    onSuccess(doNotShowAgain)
  }

  const handleChange = (event) => {
    setDoNotShowAgain(event.target.checked)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Typography variant="h3">
            <Translate id="matches.unavailable-players-alert-text" />
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={doNotShowAgain}
                onChange={handleChange}
                name="doNotShowAgain"
              />
            }
            label={<Translate id="matches.do-not-show-again" />}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          <Translate id="button.close" />
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          variant="contained"
          autoFocus
        >
          <Translate id="button.ok" />
        </Button>
      </DialogActions>
    </Dialog>
  )
}

PlayerUnavailableAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSuccess: PropTypes.func.isRequired,
}
export default PlayerUnavailableAlertDialog
